import { fetchSettings } from '../actions/SettingsActions';
import { isErrorSelector, isFetchingSelector, isLoadedSelector } from '../selectors/LoadingSelectors';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
export function useFetchSettings() {
  const dispatch = useDispatch();
  const isLoaded = useSelector(isLoadedSelector);
  const isFetching = useSelector(isFetchingSelector);
  const isError = useSelector(isErrorSelector);
  useEffect(() => {
    if (!isLoaded && !isFetching && !isError) {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      dispatch(fetchSettings());
    }
  }, [dispatch, isError, isFetching, isLoaded]);
}